import {createAsyncThunk} from '@reduxjs/toolkit';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';
import {RootState} from 'common/src/redux/store';
import campaignsApi from '../../../campaigns.api';
import {updateDashboards} from '../insightsTab.slice';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const refreshDashboards = createAsyncThunk<void>(
  `${BreadcrumbName.CampaignInsights}/refreshDashboards`,
  async (_, {dispatch, getState}) => {
    const state = getState() as RootState;
    const id = state.campaignPage.campaignTree.campaign?.id;

    if (!id) return;

    try {
      const dashboards = await campaignsApi.getCampaignDashboards(id);

      dispatch(updateDashboards(dashboards));
    } catch (error) {
      handleApiError(error);
    }
  },
);

export default refreshDashboards;
